import * as React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { noop, isEqual } from 'lodash';

import CompsRangeForm from '../tools/comps-chomper/CompsRange';
import CompsContent from '../tools/comps-chomper/CompsContent';
import { getRelatedListings } from '../../../actions/comps';
import Summary from '../tools/comps-chomper/Summary';
import EventEmitter from '../../../lib/eventEmitter';
import NoResults from '../../utility/NoResults';
import styles from './styles';
import { isMobile } from '../../../lib/getDeviceSize';

interface Props {
  activeComps: any;
  activeCompsLoading: boolean;
  classes: any;
  dispatch: any;
  showEditButton: Function;
  soldComps: any;
  soldCompsLoading: boolean;
  listing: any;
}

interface State {
  animateSummary: boolean;
  comps: any[];
  excludedListings: any[];
  isSummaryOpen: boolean;
  selectedListings: any[];
  showSettings: boolean;
}

export class Estimate extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    // Fetch comps
    this.props.dispatch(getRelatedListings(this.props.listing.id, true, 3));
    // Fetch related listings
    this.props.dispatch(getRelatedListings(this.props.listing.id, false, 3));
    this.state = {
      animateSummary: true,
      comps: [],
      excludedListings: [],
      isSummaryOpen: true,
      selectedListings: [],
      showSettings: false,
    };
  }

  componentDidMount() {
    const comps = this.getComps();
    this.setState({
      comps,
      selectedListings: comps,
    });
    EventEmitter.on('showCompsForm', this.toggleView);
  }
  componentWillUnmount() {
    EventEmitter.removeListener('showCompsForm', this.toggleView);
  }

  disableAnimation = () => {
    this.setState({
      animateSummary: false,
    });
  };

  enableAnimation = () => {
    this.setState({
      animateSummary: false,
    });
  };

  handleSummaryToggle = (isSummaryOpen: boolean) => {
    this.setState({
      isSummaryOpen,
    });
  };

  componentDidUpdate(prevProps: Props) {
    if (
      (this.props.soldComps &&
        this.props.soldComps.length > 0 &&
        !isEqual(prevProps.soldComps, this.props.soldComps)) ||
      (this.props.activeComps &&
        this.props.activeComps.length > 0 &&
        !isEqual(prevProps.activeComps, this.props.activeComps))
    ) {
      this.setState({ selectedListings: this.getComps() });
    }
  }

  getComps = () => {
    const { soldComps, activeComps } = this.props;
    const comps =
      soldComps && soldComps.length > 0
        ? soldComps
        : activeComps && activeComps.length > 0
        ? activeComps
        : [];

    this.setState({
      comps,
    });
    return comps;
  };

  onListingSelect = (selectedListing: any) => {
    const isListingAlreadySelected =
      this.state.selectedListings.filter(
        (listingItem: any) => selectedListing.id === listingItem.id,
      ).length > 0;

    this.setState({
      excludedListings: isListingAlreadySelected
        ? [...this.state.excludedListings, selectedListing]
        : this.state.excludedListings.filter(
            (listingItem: any) => selectedListing.id !== listingItem.id,
          ),
      selectedListings: isListingAlreadySelected
        ? this.state.selectedListings.filter(
            (listingItem: any) => selectedListing.id !== listingItem.id,
          )
        : [...this.state.selectedListings, selectedListing],
    });
  };

  getLoading = () => {
    if (this.props.soldComps && this.props.soldCompsLoading) {
      return true;
    }
    if (this.props.activeComps && this.props.activeCompsLoading) {
      return true;
    }
    return false;
  };
  toggleView = () => {
    this.props.showEditButton(this.state.showSettings);
    this.setState({
      showSettings: !this.state.showSettings,
    });
  };

  render() {
    const { listing } = this.props;
    const { showSettings } = this.state;
    if (!listing.squareFeet) {
      return (
        <NoResults
          emptyText="Oops! It looks like we're missing data for this property, and can't estimate a price."
          bottomText
          padTop
        />
      );
    }
    if (isMobile()) {
      return (
        <React.Fragment>
          {showSettings ? (
            <div style={{ marginBottom: 50 }}>
              <CompsRangeForm
                excludedListings={this.state.excludedListings}
                hideSearchButton
                initialFormState={{}}
                listing={this.props.listing}
                loading={false}
                onNewSearchPress={() => noop}
                onSubmit={() => {
                  this.enableAnimation();
                  this.toggleView();
                }}
                soldComps={this.state.selectedListings}
                startWithActiveComps={true}
                transparent
              />
            </div>
          ) : (
            <React.Fragment>
              {this.state.comps.length > 0 && (
                <Summary
                  animateSummaryProps={{
                    animateSummary: this.state.animateSummary,
                    callback: this.disableAnimation,
                  }}
                  isSummaryOpen={this.state.isSummaryOpen}
                  handleSummaryToggle={this.handleSummaryToggle}
                  listing={this.props.listing}
                  loading={this.getLoading()}
                  soldComps={this.state.selectedListings}
                />
              )}
              <div style={{ marginTop: 80 }}>
                <CompsContent
                  comps={this.state.comps}
                  listing={this.props.listing}
                  selectedListings={this.state.selectedListings}
                  onListingSelect={this.onListingSelect}
                />
              </div>
            </React.Fragment>
          )}
        </React.Fragment>
      );
    }
    return (
      <div>
        <CompsRangeForm
          excludedListings={this.state.excludedListings}
          hideSearchButton
          initialFormState={{}}
          listing={this.props.listing}
          loading={false}
          onNewSearchPress={() => noop}
          onSubmit={() => noop}
          soldComps={this.state.selectedListings}
          startWithActiveComps={true}
          transparent
        />
        {this.state.comps.length > 0 && (
          <CompsContent
            comps={this.state.comps}
            listing={this.props.listing}
            selectedListings={this.state.selectedListings}
            onListingSelect={this.onListingSelect}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  activeComps: state.comps.relatedListings,
  activeCompsLoading: state.comps.relatedListingsLoading,
  soldComps: state.comps.comps,
  soldCompsLoading: state.comps.compsLoading,
});

export default connect(mapStateToProps)(withStyles(styles)(Estimate));
